import { Component, computed, input, signal } from '@angular/core';

import { StreamingEntry } from './vb-lxp-admin-settings.service';

@Component({
	selector: 'vb-lxp-streaming-table',
	standalone: true,
	templateUrl: './vb-lxp-streaming-table.component.html',
	styleUrls: ['./vb-lxp-streaming-table.component.css'],
})
export class VbLxpStreamingTableComponent {
	readonly rows = input.required<StreamingEntry[]>();
	readonly searchQuery = signal('');

	readonly filteredRows = computed(() => {
		const query = this.searchQuery().toLowerCase().trim();
		if (!query) {
			return this.rows();
		}

		return this.rows().filter(row => {
			const teamName = row.teamName?.toLowerCase() || '';
			const carNumber = row.carNumber?.toString().toLowerCase() || '';
			const deviceNumber = row.carDeviceNumber?.toString().toLowerCase() || '';

			return (
				teamName.includes(query) ||
				carNumber.includes(query) ||
				deviceNumber.includes(query)
			);
		});
	});

	onSearchChange(value: string): void {
		this.searchQuery.set(value);
	}

	clearSearch(): void {
		this.searchQuery.set('');
	}
}
